import { request } from "../../apis";

export const apiGetUserLevels = (): any =>
  request("get", `/api/skill/userlevel/list`, null, true);
